import { render, staticRenderFns } from "./TheNavigationDrawer.vue?vue&type=template&id=123921b9&scoped=true"
import script from "./TheNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./TheNavigationDrawer.vue?vue&type=script&lang=js"
import style0 from "./TheNavigationDrawer.vue?vue&type=style&index=0&id=123921b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_prettier@3.3.3_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123921b9",
  null
  
)

export default component.exports